import React, { Component } from "react";

import Base from "./Base";
import Footer from "../Home/Base/Footer";

class index extends Component {
	// NOSONAR
	componentDidMount() {
		window.onUsersnapLoad = function (api) {
			api.init();
		};

		const script = document.createElement("script");
		script.defer = 1;
		script.src =
			"https://widget.usersnap.com/global/load/9fbb0618-1b2d-4bf1-8464-abfd95a30b62?onload=onUsersnapLoad";
		document.body.appendChild(script);
	}
	render() {
		return (
			<div>
				<Base props={this.props} />
				<Footer />
			</div>
		);
	}
}

export default index;
